module.exports = __webpack_public_path__ + "img/bdesc1.89fe40b7.png";